const ProfitCalculation = () => {
	return <div>ProfitCalculation</div>;
};

export default ProfitCalculation;
